import { Modal, Button, Typography, Row, Col, Switch, DatePicker } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  mobileModalSelector,
  actionMKTProduct,
} from "../../../../../redux/slices/marketing/product";
import {
  disabledEndDateSplit,
  disabledEndTimeSplit,
} from "../../../../util/helper";

const ShowMobileModal = ({ onSave }) => {
  const dispatch = useDispatch();
  const { isOpen, productData } = useSelector(mobileModalSelector);
  const { CLOSE_MOBILE_MODAL, UPDATE_MOBILE_MODAL_DATA } = actionMKTProduct;

  if (!isOpen || !productData) return null;

  const updateField = (field, value) =>
    dispatch(UPDATE_MOBILE_MODAL_DATA({ field, value }));

  const handleSwitchChange = (checked) => {
    if (!checked) {
      updateField("code", null);
      updateField("start_date", null);
      updateField("end_date", null);
    } else {
      updateField("code", "mobile");
    }
  };

  const isMobileEnabled = productData.code === "mobile";
  const { start_date, end_date } = productData;

  return (
    <Modal
      title="ช่องทางการสั่งซื้อ"
      visible={isOpen}
      onCancel={() => dispatch(CLOSE_MOBILE_MODAL())}
      footer={[
        <Button key="close" onClick={() => dispatch(CLOSE_MOBILE_MODAL())}>
          Close
        </Button>,
        <Button key="save" type="primary" onClick={() => onSave(productData)}>
          Save
        </Button>,
      ]}
      destroyOnClose
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Row align="middle">
            <Col span={8}>
              <Typography.Text>สถานะ Mobile:</Typography.Text>
            </Col>
            <Col span={16}>
              <Switch checked={isMobileEnabled} onChange={handleSwitchChange} />
            </Col>
          </Row>
        </Col>

        {isMobileEnabled && (
          <>
            <Col span={24}>
              <Row align="middle">
                <Col span={8}>
                  <Typography.Text>วันที่เริ่มต้น:</Typography.Text>
                </Col>
                <Col span={16}>
                  <DatePicker
                    style={{ width: "100%" }}
                    showTime={{ defaultValue: moment("00:00:00", "HH:mm:ss") }}
                    value={start_date ? moment(start_date) : null}
                    onChange={(date) => {
                      updateField("start_date", date);
                      updateField("end_date", null);
                    }}
                    format="DD/MM/YYYY HH:mm:ss"
                    placeholder="เลือกวันที่เริ่มต้น"
                  />
                </Col>
              </Row>
            </Col>

            <Col span={24}>
              <Row align="middle">
                <Col span={8}>
                  <Typography.Text>วันที่สิ้นสุด:</Typography.Text>
                </Col>
                <Col span={16}>
                  <DatePicker
                    style={{ width: "100%" }}
                    showTime={{ defaultValue: moment("23:59:59", "HH:mm:ss") }}
                    value={end_date ? moment(end_date) : null}
                    onChange={(e) => {
                      if (!e) {
                        updateField("end_date", null);
                        return;
                      }
                      let endMoment = moment(e);
                      if (start_date) {
                        const start = moment(start_date).add(1, "s");
                        if (
                          +moment(start).format("DD") ===
                          +moment(endMoment).format("DD")
                        ) {
                          const current_hour = +moment(endMoment).format("HH");
                          const start_hour = +moment(start).format("HH");

                          if (
                            current_hour === start_hour &&
                            current_hour !== +moment(end_date).format("HH")
                          ) {
                            endMoment = moment(endMoment).set({
                              m: +moment(start).format("mm"),
                              s: +moment(start).format("ss"),
                            });
                          }
                        }
                      }
                      updateField("end_date", endMoment);
                    }}
                    format="DD/MM/YYYY HH:mm:ss"
                    placeholder="เลือกวันที่สิ้นสุด"
                    disabledDate={(current) =>
                      disabledEndDateSplit(current, start_date)
                    }
                    disabledTime={(current) =>
                      disabledEndTimeSplit(current, start_date)
                    }
                  />
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </Modal>
  );
};

export default ShowMobileModal;
